import React from 'react';
import { Grid } from '@mui/material';
import CreateClinicForm from '../CreateClinic/CreateClinicForm';
import {ClinicTagsAutocompleteProvider} from '../../components/ClinicTagsHookFormAutocomplete';

export default function ClinicStep({ control, errors, handleRetrieve }) {
  return (
    <Grid item xs={12} sx={{mb: 2, mr: 2}}>
        <ClinicTagsAutocompleteProvider tags={[]}>
            <CreateClinicForm
                prefix="clinic"
                control={control}
                errors={errors}
                handleRetrieve={handleRetrieve}
            />
        </ClinicTagsAutocompleteProvider>
    </Grid>
  );
}
